import { memo, type ReactNode } from "react";
import { useIntelligentCycleCountsFlag } from "./intelligent-cycle-counts-flag-provider";

export const IntelligentCycleCountsFlagGate = memo(
  function IntelligentCycleCountsFlagGate({
    children,
  }: {
    children: ReactNode;
  }) {
    const enabled = useIntelligentCycleCountsFlag();

    if (!enabled) {
      return null;
    }

    return <>{children}</>;
  },
);
